import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

const Login = () => import(/* webpackChunkName: "about" */ './views/Login.vue');
const ArticleIndex = () => import(/* webpackChunkName: "article/index" */ './views/Article/Index.vue');
const ArticleInfo = () => import(/* webpackChunkName: "article/info" */ './views/Article/Info.vue');
const BannerIndex = () => import(/* webpackChunkName: "banner/index" */ './views/Banner/Index.vue');
const BannerInfo = () => import(/* webpackChunkName: "banner/info" */ './views/Banner/Info.vue');
const MenuIndex = () => import(/* webpackChunkName: "menu/index" */ './views/Menu/Index.vue');
const MenuInfo = () => import(/* webpackChunkName: "menu/info" */ './views/Menu/Info.vue');
const SettingSeo = () => import(/* webpackChunkName: "setting/seo" */ './views/Setting/Seo.vue');

Vue.use(Router);

export default new Router({
  linkActiveClass: 'is-active',
  linkExactActiveClass: 'is-active',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/banner',
      name: 'banner',
      component: BannerIndex,
    },
    {
      path: '/banner/create',
      name: 'banner.create',
      component: BannerInfo,
    },
    {
      path: '/banner/:id',
      name: 'banner.info',
      component: BannerInfo,
    },
    {
      path: '/article',
      name: 'article',
      component: ArticleIndex,
    },
    {
      path: '/article/create',
      name: 'article.create',
      component: ArticleInfo,
    },
    {
      path: '/article/:id',
      name: 'article.info',
      component: ArticleInfo,
    },
    {
      path: '/menu',
      name: 'menu',
      component: MenuIndex,
    },
    {
      path: '/menu/create',
      name: 'menu.create',
      component: MenuInfo,
    },
    {
      path: '/menu/:id',
      name: 'menu.info',
      component: MenuInfo,
    },
    {
      path: '/setting/seo',
      name: 'setting.seo',
      component: SettingSeo,
    },
  ],
});
